import React from "react";
import {Route, Routes} from "react-router-dom";
import {AuthLayout} from "./AuthLayout";
import {EmployeeEmailFP} from "../pages/authentication/forgotPassword/EmployeeEmailFP";
import {OneTimePinFP} from "../pages/authentication/forgotPassword/OneTimePinFP";
import {CreatePasswordFP} from "../pages/authentication/forgotPassword/CreatePasswordFP";
import {SuccessFP} from "../pages/authentication/forgotPassword/SuccessFP";


export const UnAuthenticatedRoutesForgotPassword = () => {
    return (
        <AuthLayout>
            <Routes>
                {/*====== Forgot Password =======*/}
                <Route path="/ssp" element={<EmployeeEmailFP />} />
                <Route path="/one-time-password" element={<OneTimePinFP />} />
                <Route path="/create-password" element={<CreatePasswordFP />} />
                <Route path="/success" element={<SuccessFP />} />
            </Routes>
        </AuthLayout>
    )
}